import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, HeadContent, Outlet, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { OfflineBanner } from "@/app/offline-banner";
import { AUTH_LOST_EVENT, setCurrentOrgId } from "@/lib/api/client";
import { queryClient } from "@/lib/api/query-client";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
});

function Root() {
  const router = useRouter();
  // The session ended elsewhere (expired cookie, sign-out in another tab): back to sign-in.
  useEffect(() => {
    const lost = () => {
      setCurrentOrgId(null);
      queryClient.clear();
      void router.navigate({ to: "/login", search: { expired: true, redirect: location.pathname + location.search } });
    };
    window.addEventListener(AUTH_LOST_EVENT, lost);
    return () => window.removeEventListener(AUTH_LOST_EVENT, lost);
  }, [router]);
  return (
    <>
      <HeadContent />
      <OfflineBanner />
      <Outlet />
    </>
  );
}
